import Vue from 'vue';
import VueCustomElement from 'vue-custom-element';
import RatingMobile from 'static-components/src/vue/rating/rating-mobile.vue';
import { vueCustomElementOptions } from 'static-components/src/vue-customelement-options';
var initializeRatingMobile = function () {
    Vue.use(VueCustomElement);
    // @ts-ignore
    Vue.customElement('c-rating-mobile', (new RatingMobile().$options), vueCustomElementOptions);
};
export default initializeRatingMobile;
